// トラック情報をCartAttributeに登録する
function setAttribute(track_info) {
  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      attributes: { トラック情報: track_info },
    }),
  })
    .then((response) => response.json())
    .catch((error) => {
      //console.error('Error:', error);
    });
}

function convertJsonToString(jsonData) {
  let result = "";

  jsonData.rates.forEach((rate) => {
    Object.entries(rate.track_list).forEach(([areaId, trucks]) => {
      result += `【エリアグループID：${areaId}】\n`;

      Object.entries(trucks).forEach(([truckType, truckList]) => {
        truckList.forEach((truck) => {
          if (truck.products.length > 0) {
            result += `[${truckType}]\n`;
            result += `積載する商品：${truck.products.join(" , ")}\n`;
            result += `配送先：${customer_address}\n`;
            result += `出発地点から目的地までの距離：${truck.distance}km\n\n`;
          }
        });
      });
    });
  });

  //console.log(result);
  return result;
}

function getShippingRate() {
  const parameter = {
    rate: {
      origin: {
        city: shop_address,
        address1: "",
      },
      destination: {
        city: customer_address,
        address1: "",
      },
      items: products,
    },
  };
  switch (window.location.hostname) {
    case "localhost":
    case "dev-tenteco.myshopify.com":
      apiBaseUrl = "https://dashboard.fuel.noren.io";
      break;
    case "staging-tenteco.myshopify.com":
      apiBaseUrl = "https://dashboard.service-stg.tenteco.jp"; // 検証用のURLを入れる
      break;
    case "tenteco.jp":
      apiBaseUrl = "https://dashboard.service.tenteco.jp"; // '本番用のURLを入れる'
      break;
    default:
      apiBaseUrl = "https://dashboard.fuel.noren.io"; // デフォルトURL（必要に応じて設定）
      break;
  }
  fetch(apiBaseUrl + "/api/carrier_service", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(parameter),
  })
    .then((response) => response.json())
    .then((data) => {
      // ローカル,開発,検証の場合のみログを出力する
      // switch (window.location.hostname) {
      //     case 'localhost':
      //     case 'dev-tenteco.myshopify.com':
      //     case 'staging-tenteco.myshopify.com':
      //       console.log(data);
      //       break;
      //     default:
      //       break;
      // }
      var elm = document.getElementById("custom-ship");
      // carrierServiceAPIの仕様上、100をかけた値が返るので100を割る
      // 運賃の税込価格、税抜価格、税金を算出
      var customShippingRateNoTax = data["rates"][0]["total_price"] / 100;
      // 取得した税抜運賃を動的に運賃を更新する
      elm.textContent = "¥" + customShippingRateNoTax.toLocaleString();

      // 消費税を計算
      total_price = total_price / 100;
      var noTaxPrice = total_price + customShippingRateNoTax;
      var totalTax = Math.round(noTaxPrice * 0.1);
      var allPrice = noTaxPrice + totalTax;

      // 新たな総計をセットする
      let elm2 = document.getElementById("total-price");
      elm2.textContent = "¥" + allPrice.toLocaleString();

      // 新たな合計消費税をセットする
      let elm3 = document.getElementById("total-tax");
      elm3.textContent = "¥" + totalTax.toLocaleString();

      //console.log(data['rates'][0]);

      let trackCounts = {};

      // 配列の要素数をカウントして合計を計算
      Object.keys(data["rates"][0]["track_list"]).forEach((area) => {
        Object.keys(data["rates"][0]["track_list"][area]).forEach(
          (trackType) => {
            const count =
              data["rates"][0]["track_list"][area][trackType].length;
            if (!trackCounts[trackType]) {
              trackCounts[trackType] = 0;
            }
            trackCounts[trackType] += count;
          }
        );
      });

      // 合計数を基にテキストを作成
      let trackText = "";
      Object.keys(trackCounts).forEach((trackType) => {
        if (trackCounts[trackType] > 0) {
          trackText += `${trackType}:${trackCounts[trackType]}台 `;
        }
      });

      // 末尾の空白をトリム
      trackText = trackText.trim();

      // カートにトラックを表示
      let elm4 = document.getElementById("track-text");

      elm4.textContent = trackText;

      // CartAttributeにトラック情報を登録して受注管理でトラック情報を参照可能にする
      setAttribute(convertJsonToString(data));
    })
    .catch((error) => {
      //console.log('Error:', error);
    });
}

getShippingRate();
